import { ExpertRole } from "../../../utils/Enums";

export const shouldShowExpert = (currentRole: ExpertRole, expertType: ExpertRole) => {
    if (currentRole === ExpertRole.Admin) return true;
    if (expertType === ExpertRole.Nutritionist) return currentRole !== ExpertRole.Nutritionist;
    if (expertType === ExpertRole.Physician) return currentRole !== ExpertRole.Nutritionist && currentRole !== ExpertRole.Physician;
    return false;
}